import { Observable } from 'rxjs';
import { Actions } from '../../actions';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { push } from 'connected-react-router';
import { ForgotPasswordSuccess, ForgotPasswordStartSuccess } from '../../auth/action-creators';
import { FORGOT_PASSWORD_START_SUCCESS, FORGOT_PASSWORD_SUCCESS } from '../../auth/actions';

export const forgotPasswordEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, ForgotPasswordStartSuccess | ForgotPasswordSuccess>(
      FORGOT_PASSWORD_START_SUCCESS,
      FORGOT_PASSWORD_SUCCESS
    ),
    map((action) => {
      if (action.type === FORGOT_PASSWORD_START_SUCCESS) {
        return push(`/login/forgot-password/verify?account=${encodeURIComponent(action.username)}`)
      }
      if (action.type === FORGOT_PASSWORD_SUCCESS) {
        return push('/login')
      }
    })
  );